module.exports = "https://trybtryb-legacy.web.app/img/instagram_grey.1a80eaef.svg";